export enum MediaQueryLimit {
	SMALL = 600,
	MEDIUM = 1023,
	LARGE = 1200
}
